import { render, staticRenderFns } from "./digital-relics.vue?vue&type=template&id=9d1b6704&scoped=true"
import script from "./digital-relics.vue?vue&type=script&lang=js"
export * from "./digital-relics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1b6704",
  null
  
)

export default component.exports